import { createSlice } from "@reduxjs/toolkit";

//initial state

const initialState = {
  value: 0,
};

//reducers

export const counterSlice = createSlice({
  name: "counter",
  initialState,
  reducers: {
    increment: (state, action) => {
      state.value += 1;
    },
    decrement: (state, action) => {
      state.value -= 1;
    },
    incrementByAmount: (state, action) => {
      state.value += action.payload;
    },
  },
});

// export actions

export const { increment, decrement, incrementByAmount } = counterSlice.actions;

export default counterSlice.reducer;
